export interface CartCountResponse {
  count: number
}

export function parseCartCountResponse(raw: any): CartCountResponse {
  if (!raw || typeof raw !== 'object') {
    throw new Error('Invalid response format: expected object')
  }

  if (typeof raw.count !== 'number') {
    throw new Error('Invalid response format: count must be a number')
  }

  return {
    count: raw.count,
  }
}
